<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <div class="navbar-brand text-capitalize" href="javascript:void(0)">Bank Report</div>
      <div class="d-flex flex-row gap-3 align-items-center">
        <strong>Select Date</strong>
        <input type="date" [(ngModel)]="date" (change)="inputchange()" [max]="today" class="form-control w-auto" />
      </div>
    </div>
  </nav>
  <hr class="mt-0"/>
  <app-table #history></app-table>
